/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#konten[_ngcontent-%COMP%]{margin:10px}.portlet-blue[_ngcontent-%COMP%]{background-color:#3598dc}.portlet-blue[_ngcontent-%COMP%]   .kt-portlet__head-title[_ngcontent-%COMP%]{color:#fff}.red-text[_ngcontent-%COMP%]{color:red}"];
export { styles as styles };
